
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import "../css/Home.css";
import LOGO from "../assets/thurent-logo.svg";
import Services from "./Services";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { logOut } from "../../store/authSlice";

function Navbar() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const user = useSelector((state) => state.user.userDetails);

  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [showServices, setShowServices] = useState(false);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutAccount = () => {
    dispatch(logOut()); 
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <div className="th-nav">
        <div className="th-nav__logo" onClick={() => navigate("/")}>
          <img src={LOGO} alt="thurent" width={"120px"} />
        </div>
        <div className="th-nav__menu">
          <span
            className={`cursor-pointer ${
              location.pathname === "/" && !showServices
                ? "th-nav__link__active"
                : "th-nav__link"
            }`}
            onClick={() => navigate("/")}
          >
            Home
          </span>
        {!isLoggedIn && <div
            onMouseEnter={() => setShowServices(true)}
            onMouseLeave={() => setShowServices(false)}
            className="relative inline-block"
          >
            <span
              className={`cursor-pointer ${
                showServices ? "th-nav__link__active" : "th-nav__link"
              }`}
            >
              Services
            </span>
            <Services
              isOpen={showServices}
              onClose={() => setShowServices(false)}
            />
          </div>
}
          <span
            className={`cursor-pointer ${
              location.pathname === "/about-us" && !showServices
                ? "th-nav__link__active"
                : "th-nav__link"
            }`}
            onClick={() => navigate("/about-us")}
          >
            About Us
          </span>
          <span
            className={`cursor-pointer ${
              location.pathname === "/contact" && !showServices
                ? "th-nav__link__active"
                : "th-nav__link"
            }`}
            onClick={() => navigate("/contact")}
          >
            Contact
          </span>
        </div>
        <div className="th-nav__login">
          <div className="th-nav__login__container">
            {!isLoggedIn ? (
              <>
                <span
                  className="th-nav__auth"
                  style={{
                    padding: "12px",
                  }}
                  onClick={() => navigate("/login")}
                >
                  Log-in / Sign-Up
                </span>
                <div
                  className="th-nav__provider"
                  onClick={() => navigate("/service-provider/login")}
                >
                  <span className="th-nav__provider__txt">
                    Service provider
                  </span>
                </div>
              </>
            ) : (
              <>
                <span
                  className="th-nav__auth flex align-items-center gap-2 align-self-center"
                  style={{
                    padding: "12px",
                  }}
                  onClick={logoutAccount}
                >
                  Logout
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.54199 5.86067C2.54199 4.0044 4.09797 2.54199 5.96278 2.54199H9.6083C11.4737 2.54199 13.0298 4.00429 13.0298 5.86067V6.53232C13.0298 6.90009 12.7317 7.19822 12.3639 7.19822C11.9962 7.19822 11.698 6.90009 11.698 6.53232V5.86067C11.698 4.78711 10.7864 3.87378 9.6083 3.87378H5.96278C4.78554 3.87378 3.87378 4.787 3.87378 5.86067V13.873C3.87378 14.9467 4.78554 15.8599 5.96278 15.8599H9.61578C10.7896 15.8599 11.698 14.9499 11.698 13.8809V13.2021C11.698 12.8343 11.9962 12.5362 12.3639 12.5362C12.7317 12.5362 13.0298 12.8343 13.0298 13.2021V13.8809C13.0298 15.7332 11.4765 17.1917 9.61578 17.1917H5.96278C4.09798 17.1917 2.54199 15.7293 2.54199 13.873V5.86067ZM7.43664 9.67874C7.43664 9.31098 7.73478 9.01285 8.10254 9.01285H14.9132L14.0077 8.11137C13.7471 7.8519 13.7462 7.43028 14.0056 7.16966C14.2651 6.90903 14.6867 6.90809 14.9473 7.16756L16.991 9.20216C17.1149 9.32309 17.1919 9.49193 17.1919 9.67874C17.1919 9.8675 17.1133 10.0379 16.9871 10.1591L14.9474 12.1904C14.6868 12.4499 14.2652 12.4491 14.0057 12.1885C13.7462 11.9279 13.7471 11.5063 14.0076 11.2468L14.9135 10.3446H8.10254C7.73478 10.3446 7.43664 10.0465 7.43664 9.67874Z"
                      fill="#383838"
                    />
                  </svg>
                </span>
                <span
                  className="th-nav__auth flex align-items-center gap-2 align-self-center"
                  style={{
                    padding: "12px",
                  }}
                  onClick={() => navigate("/dashboard/my-account")}
                >
                  {user?.firstName || "User"}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.625 10C17.625 5.85757 14.2674 2.5 10.125 2.5C5.98257 2.5 2.625 5.85757 2.625 10C2.625 14.1416 5.98257 17.5 10.125 17.5C14.2674 17.5 17.625 14.1416 17.625 10Z"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.83496 16.1452C6.00524 14.8235 7.18091 13.356 10.0998 13.356C13.0512 13.356 14.2188 14.8317 14.3809 16.1695"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.8487 8.60558C12.8487 10.1226 11.6195 11.3518 10.1025 11.3518C8.58549 11.3518 7.35547 10.1226 7.35547 8.60558C7.35547 7.08857 8.58549 5.85938 10.1025 5.85938C11.6195 5.85938 12.8487 7.08857 12.8487 8.60558Z"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="th-nav__sm">
        <div className="th-nav__logo" onClick={() => navigate("/")}>
          <img src={LOGO} alt="thurent" width={"120px"} />
        </div>
        {!toggleSidebar && (
          <Button
            icon={"pi pi-bars"}
            rounded
            text
            aria-label="Hamburger"
            style={{
              backgroundColor: "white",
              color: "#383838",
              borderRadius: "50%",
              border: "none",
              width: "40px",
              height: "40px",
            }}
            onClick={() => setToggleSidebar(!toggleSidebar)}
          />
        )}
        <Sidebar
          visible={toggleSidebar}
          header={
            <div className="th-nav__logo" onClick={() => navigate("/")}>
              <img src={LOGO} alt="thurent" width={"120px"} />
            </div>
          }
          onHide={() => setToggleSidebar(false)}
        >
          <div className="flex flex-column gap-5 my-3 h-screen">
            <span
              className={`cursor-pointer th-nav__link th-nav__sm__link th-nav__sm__link__dropdown__item`}
              onClick={() => navigate("/")}
            >
              Home
            </span>
            <span className={`th-nav__link th-nav__sm__link`}>
              Services <i className="pi pi-angle-down"></i>
              <ul className="th-nav__sm__link__dropdown flex flex-column gap-3 list-none">
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() => navigate("/service/ai-enabled-event-details")}
                >
                  AI Enabled Event Details
                </li>
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() => navigate("/service/book-catering")}
                >
                  Order Catering
                </li>
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() =>
                    navigate("/service/rental-services-for-events")
                  }
                >
                  Rent From Tent Houses
                </li>
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() => navigate("/service/invite")}
                >
                  Send Invitation
                </li>
                <li
                  className="th-nav__sm__link__dropdown__item"
                  onClick={() => navigate("/service/hire-a-priest")}
                >
                  Book A Priest
                </li>
              </ul>
            </span>
            <span
              className={`cursor-pointer th-nav__link th-nav__sm__link th-nav__sm__link__dropdown__item`}
              onClick={() => navigate("/about-us")}
            >
              About Us
            </span>
            <span
              className={`cursor-pointer th-nav__link th-nav__sm__link th-nav__sm__link__dropdown__item`}
              onClick={() => navigate("/contact")}
            >
              Contact
            </span>
          </div>
          <div className={`th-nav__sm__footer ${!isLoggedIn && "w-auto"}`}>
            {!isLoggedIn ? (
              <>
                <span
                  className="th-nav__auth"
                  style={{
                    padding: "12px",
                  }}
                  onClick={() => navigate("/login")}
                >
                  Log-in / Sign-Up
                </span>
                <div
                  className="th-nav__provider"
                  onClick={() => navigate("/service-provider/login")}
                >
                  <span className="th-nav__provider__txt">
                    Service provider
                  </span>
                </div>
              </>
            ) : (
              <>
                <span
                  className="th-nav__auth  w-full flex align-items-center gap-2 align-self-center"
                  style={{
                    padding: "12px",
                  }}
                  onClick={logoutAccount}
                >
                  Logout
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.54199 5.86067C2.54199 4.0044 4.09797 2.54199 5.96278 2.54199H9.6083C11.4737 2.54199 13.0298 4.00429 13.0298 5.86067V6.53232C13.0298 6.90009 12.7317 7.19822 12.3639 7.19822C11.9962 7.19822 11.698 6.90009 11.698 6.53232V5.86067C11.698 4.78711 10.7864 3.87378 9.6083 3.87378H5.96278C4.78554 3.87378 3.87378 4.787 3.87378 5.86067V13.873C3.87378 14.9467 4.78554 15.8599 5.96278 15.8599H9.61578C10.7896 15.8599 11.698 14.9499 11.698 13.8809V13.2021C11.698 12.8343 11.9962 12.5362 12.3639 12.5362C12.7317 12.5362 13.0298 12.8343 13.0298 13.2021V13.8809C13.0298 15.7332 11.4765 17.1917 9.61578 17.1917H5.96278C4.09798 17.1917 2.54199 15.7293 2.54199 13.873V5.86067ZM7.43664 9.67874C7.43664 9.31098 7.73478 9.01285 8.10254 9.01285H14.9132L14.0077 8.11137C13.7471 7.8519 13.7462 7.43028 14.0056 7.16966C14.2651 6.90903 14.6867 6.90809 14.9473 7.16756L16.991 9.20216C17.1149 9.32309 17.1919 9.49193 17.1919 9.67874C17.1919 9.8675 17.1133 10.0379 16.9871 10.1591L14.9474 12.1904C14.6868 12.4499 14.2652 12.4491 14.0057 12.1885C13.7462 11.9279 13.7471 11.5063 14.0076 11.2468L14.9135 10.3446H8.10254C7.73478 10.3446 7.43664 10.0465 7.43664 9.67874Z"
                      fill="#383838"
                    />
                  </svg>
                </span>
                <span
                  className="th-nav__auth w-full flex align-items-center gap-2 align-self-center"
                  style={{
                    padding: "12px",
                  }}
                  onClick={() => navigate("/dashboard/my-account")}
                >
                  {user?.firstName || "User"}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.625 10C17.625 5.85757 14.2674 2.5 10.125 2.5C5.98257 2.5 2.625 5.85757 2.625 10C2.625 14.1416 5.98257 17.5 10.125 17.5C14.2674 17.5 17.625 14.1416 17.625 10Z"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.83496 16.1452C6.00524 14.8235 7.18091 13.356 10.0998 13.356C13.0512 13.356 14.2188 14.8317 14.3809 16.1695"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.8487 8.60558C12.8487 10.1226 11.6195 11.3518 10.1025 11.3518C8.58549 11.3518 7.35547 10.1226 7.35547 8.60558C7.35547 7.08857 8.58549 5.85938 10.1025 5.85938C11.6195 5.85938 12.8487 7.08857 12.8487 8.60558Z"
                      stroke="#383838"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </>
            )}
          </div>
        </Sidebar>
      </div>
    </>
  );
}

export default Navbar;
